import { cn } from "@/lib/utils";

export function richTextBoxClass({
  invalid = false,
  disabled = false,
  className,
}: {
  invalid?: boolean;
  disabled?: boolean;
  className?: string;
} = {}) {
  return cn(
    "overflow-hidden rounded-md border border-input bg-white shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring",
    invalid && "border-destructive focus-within:ring-destructive",
    disabled && "opacity-60",
    className,
  );
}

export function richTextBodyClass({
  compact = false,
  expanded = false,
}: {
  compact?: boolean;
  expanded?: boolean;
} = {}) {
  return cn(
    "flex cursor-text flex-col overflow-y-auto",
    expanded
      ? "min-h-editor-expanded max-h-editor-expanded"
      : cn("max-h-editor", compact ? "min-h-editor-sm" : "min-h-editor"),
  );
}

export const RICH_TEXT_TOOLBAR =
  "flex flex-wrap items-center gap-0.5 border-b border-input bg-slate-50 px-1.5 py-1";
